export default {
  avatar: {
    main: 'dt.shared.header.avatar.main',
    drawer: {
      dropdownLink: 'dt.shared.header.avatar.drawer.dropdownLink',
      username: 'dt.shared.header.avatar.drawer.username',
    },
    hoverCard: {
      balance: 'dt.shared.header.avatar.hoverCard.balance',
      username: 'dt.shared.header.avatar.hoverCard.username',
    },
  },
  burgerMenuButton: 'dt.shared.header.burgerMenuButton',
  quickPicksButton: 'dt.shared.header.quickPicksButton',
  signedOutHeaderButton: 'dt.shared.header.signedOutHeaderButton',
  predictionMarketsButton: 'dt.shared.header.predictionMarketsButton',
  contestCreateButton: 'dt.shared.header.contestCreateButton',
};
